export default function stringDollarToCentHundredths(value: string): number {
    if (value.length === 0) {
        return NaN;
    }

    const segments = value.split(".");

    if (segments.length > 2) {
        return NaN;
    }

    const dollarAmount = parseInt(segments[0]);
    let centAmount = 0;

    if (isNaN(dollarAmount)) {
        return NaN;
    }

    if (segments.length === 2) {
        // have sentgs
        centAmount = parseInt(segments[1]);
        if (isNaN(centAmount) || segments[1].length === 0) {
            return NaN;
        }
    }

    return dollarAmount * 10000 + centAmount * 100;
}
